import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import { v4 as uuidv4 } from 'uuid';

import { ticketAtom } from '@/pages/Ticket';

const TemplateCustomDataEnvironments = () => {
  const [{ custom_data }] = useAtom(ticketAtom);

  return (
    <>
      <Divider sx={{ borderWidth: '1px' }} />
      <Typography variant="h5">
        Details of the requested Internal Networks update:
      </Typography>
      <TableContainer>
        <Table style={{ display: 'table', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 0, width: '10rem' }}>Action</TableCell>
              <TableCell sx={{ py: 0 }}>IP Address</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {custom_data?.environments?.add &&
              custom_data?.environments.add.length !== 0 && (
                <TableRow>
                  <TableCell
                    sx={{
                      py: 1,
                      textTransform: 'uppercase',
                      verticalAlign: 'top'
                    }}
                  >
                    add
                  </TableCell>
                  <TableCell
                    sx={{
                      py: 1,
                      wordWrap: 'break-word'
                    }}
                  >
                    {custom_data?.environments.add.map((request: string) => (
                      <Box key={uuidv4()}>{request}</Box>
                    ))}
                  </TableCell>
                </TableRow>
              )}
            {custom_data?.environments?.remove &&
              custom_data?.environments.remove.length !== 0 && (
                <TableRow>
                  <TableCell
                    sx={{
                      py: 1,
                      textTransform: 'uppercase',
                      verticalAlign: 'top'
                    }}
                  >
                    remove
                  </TableCell>
                  <TableCell
                    sx={{
                      py: 1,
                      wordWrap: 'break-word'
                    }}
                  >
                    {custom_data?.environments.remove.map((request: string) => (
                      <Box key={uuidv4()}>{request}</Box>
                    ))}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplateCustomDataEnvironments;
